var map = {
	"./404-bg.webp": 50415,
	"./adobe-acrobat.svg": 91467,
	"./apartment.webp": 25516,
	"./app-icon.webp": 2972,
	"./app-store.svg": 88100,
	"./arrowTop.svg": 79992,
	"./avatar-2-female.webp": 79266,
	"./avatar-2-male.webp": 10234,
	"./avatar-female.jpg": 22858,
	"./avatar-male.jpg": 39784,
	"./bocian-voucher.webp": 23429,
	"./christmas-voucher.webp": 29631,
	"./clock.svg": 9143,
	"./de@3x.png": 17314,
	"./en@3x.png": 33073,
	"./error.svg": 68067,
	"./gastr-coupon-bg.svg": 8850,
	"./gastro-card-boost-label.webp": 65044,
	"./gastro-card-slides/gastro-card-slide-1.jpg": 67350,
	"./gastro-card-slides/gastro-card-slide-2.jpg": 45578,
	"./gastro-card-slides/gastro-card-slide-3.jpg": 50753,
	"./gastro-card-slides/gastro-card-slide-4.jpg": 82832,
	"./gastro-card-slides/gastro-card-slide-5.jpg": 54505,
	"./gastro-coupon-label.jpg": 44035,
	"./gastro-voucher-label.jpg": 17455,
	"./gastro-voucher.jpg": 43473,
	"./google-play.svg": 59080,
	"./header-gastro.png": 20513,
	"./header-vip-standard.webp": 28688,
	"./header-vip-winter.webp": 15391,
	"./holiday-benefit/invitation/gallery/01.webp": 22851,
	"./holiday-benefit/invitation/gallery/02.webp": 64775,
	"./holiday-benefit/invitation/gallery/03.webp": 16393,
	"./holiday-benefit/landing-page/animations.svg": 31761,
	"./holiday-benefit/landing-page/arrow-left-to-right.svg": 96633,
	"./holiday-benefit/landing-page/arrow-right-to-left.svg": 13080,
	"./holiday-benefit/landing-page/bar.svg": 10064,
	"./holiday-benefit/landing-page/benefits-employee.webp": 96110,
	"./holiday-benefit/landing-page/benefits.webp": 33547,
	"./holiday-benefit/landing-page/bilbox.jpg": 93236,
	"./holiday-benefit/landing-page/bocian.jpg": 1881,
	"./holiday-benefit/landing-page/gallery/01.webp": 54621,
	"./holiday-benefit/landing-page/gallery/02.webp": 1646,
	"./holiday-benefit/landing-page/gallery/03.webp": 77503,
	"./holiday-benefit/landing-page/gallery/04.webp": 74423,
	"./holiday-benefit/landing-page/gallery/05.webp": 20208,
	"./holiday-benefit/landing-page/gallery/06.webp": 85334,
	"./holiday-benefit/landing-page/gallery/07.webp": 50437,
	"./holiday-benefit/landing-page/gallery/08.webp": 45619,
	"./holiday-benefit/landing-page/gallery/09.webp": 78882,
	"./holiday-benefit/landing-page/gallery/10.webp": 51557,
	"./holiday-benefit/landing-page/gallery/11.webp": 4151,
	"./holiday-benefit/landing-page/gallery/12.webp": 60893,
	"./holiday-benefit/landing-page/gallery/13.webp": 36376,
	"./holiday-benefit/landing-page/gallery/14.webp": 86816,
	"./holiday-benefit/landing-page/header-employee-mobile.webp": 22983,
	"./holiday-benefit/landing-page/header-employee.webp": 1236,
	"./holiday-benefit/landing-page/header-mobile.webp": 8881,
	"./holiday-benefit/landing-page/header.webp": 6530,
	"./holiday-benefit/landing-page/holiday-dream.webp": 64256,
	"./holiday-benefit/landing-page/inpost.jpg": 83321,
	"./holiday-benefit/landing-page/logo.svg": 11822,
	"./holiday-benefit/landing-page/machines.svg": 10432,
	"./holiday-benefit/landing-page/motivizer-logo.webp": 1288,
	"./holiday-benefit/landing-page/mybenefit-logo.webp": 83461,
	"./holiday-benefit/landing-page/playground-2.svg": 86134,
	"./holiday-benefit/landing-page/playground.svg": 73214,
	"./holiday-benefit/landing-page/pool.svg": 29022,
	"./holiday-benefit/landing-page/vouchers.webp": 305,
	"./house.webp": 36628,
	"./icon_facebook@2x.svg": 54306,
	"./icon_insta@2x.svg": 34270,
	"./icon_youtube@2x.svg": 58823,
	"./icons_correct.svg": 81171,
	"./image-placeholder.webp": 8382,
	"./logo_bocian.svg": 3471,
	"./logo_holiday_color.svg": 65332,
	"./logo_holiday_white@3x.svg": 80352,
	"./logo_shape.png": 47958,
	"./mobile-app-banner-with-bg.webp": 7452,
	"./mobile-app-banner.png": 46340,
	"./modal-image.webp": 68266,
	"./package-wholesale-gastro_card-label.png": 78327,
	"./package-wholesale-gastro_card_boost-label.png": 7539,
	"./package-wholesale-subscription-label.png": 29573,
	"./paypo-bg.webp": 45571,
	"./paypo-logo.svg": 15325,
	"./phone.svg": 25244,
	"./pl@3x.png": 39464,
	"./pool.webp": 502,
	"./processing.svg": 85537,
	"./product-packages/description.webp": 44865,
	"./resorts/cieplice.jpg": 46175,
	"./resorts/grzybowo.jpg": 85567,
	"./resorts/mielno.jpg": 59161,
	"./resorts/niechorze.jpg": 36956,
	"./resorts/pobierowo.jpg": 54121,
	"./resorts/rowy.jpg": 31975,
	"./resorts/ustronie.jpg": 82659,
	"./sidebar.jpg": 6620,
	"./snow_layer.svg": 72461,
	"./snowflake.svg": 99015,
	"./subscription-label.jpg": 79525,
	"./subscription-variants/bronze.svg": 24417,
	"./subscription-variants/gold.svg": 94831,
	"./subscription-variants/silver.svg": 56373,
	"./subscription-with-benefits-label.webp": 40005,
	"./success.svg": 41185,
	"./sun.svg": 75056,
	"./suntago/suntago-1.webp": 37796,
	"./suntago/suntago-2.webp": 53434,
	"./suntago/suntago-3.webp": 2721,
	"./ulotka.jpg": 39311,
	"./video_poster.jpg": 85085,
	"./vip-label.png": 52678,
	"./vip-white.svg": 88445,
	"./woman.webp": 73013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;